<template>
  <div :key="`${feedbackGiven}${feedback}`">
    <MButton
      :outline="feedbackGiven && feedback ? false : true"
      variant="success"
      class="mr-4 inline-flex items-center"
      @click="$emit(feedbackGiven && feedback ? 'removed' : 'like')"
    >
      <MIcon :name="feedbackGiven && feedback ? 'check' : 'thumbs-up'" />
      {{ __t('helpful') }}
    </MButton>
    <MButton
      :outline="feedbackGiven && feedback === false ? false : true"
      variant="error"
      class="inline-flex items-center mx-1"
      @click="
        $emit(feedbackGiven && feedback === false ? 'removed' : 'dislike')
      "
    >
      <MIcon
        :name="feedbackGiven && feedback === false ? 'check' : 'thumbs-down'"
      />
      {{ __t('not_helpful') }}
    </MButton>
  </div>
</template>

<script>
export default {
  name: 'RegisterFeedback',
  props: {
    feedbackGiven: { type: Boolean, default: false },
    feedback: { type: Boolean, default: false },
  },
}
</script>
